












































































































































































































































































































































import CompanyUserRequired from "../CompanyRequired";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import {
  ApiMessage,
  Terminal,
  TerminalConfigNext,
  TerminalGuiInfo,
  TerminalLocation,
  TerminalLocationArea,
  TerminalLocationExportserviceInfo,
  TerminalLocationHmsregInfo
} from "@/modules/models";
import Api from "@/components/location/Api";
import RegWithoutTerminalInfoDialog from "./RegWithoutTerminalInfoDialog.vue";
import RequireRegcodeInfoDialog from "@/components/location/RequireRegcodeInfoDialog.vue";
import RegWithoutCardInfoText from "@/components/location/RegWithoutCardInfoText.vue";
import InfoDialog from "@/components/InfoDialog.vue";
import rd from "@/modules/vRoutedefs";
import Areamap from "@/components/location/Areamap.vue";
import {Area, Drawingmethod} from "@/modules/mapmodels";
import PolygonIcon from "@/components/location/PolygonIcon.vue";
import CircleIcon from "@/components/location/CircleIcon.vue";
import InfoBtn from "@/components/shared/InfoBtn.vue";
import Ellipsifier from "@/components/shared/Ellipsifier.vue";
import Routes from "@/modules/Routes";
import LocationTerminalSet from "@/components/location/LocationTerminalSet.vue";
import SyncInfoDialog from "@/components/terminals/SyncInfoDialog.vue";
import LocationInfoText from "@/components/docs/intro/LocationInfoText.vue";
import delay from "@/modules/delay";
import {ignoreRedundantNavErr} from "@/router";
import LocationOccurringCostInfoDialog from "@/components/location/LocationOccurringCostInfoDialog.vue";

@Component({
        components: {
            "at-without-terminal-info": RegWithoutTerminalInfoDialog,
            "at-require-regcode-dialog": RequireRegcodeInfoDialog,
            "at-info-dialog": InfoDialog,
            "at-info-btn": InfoBtn,
            "at-rwoc-info": RegWithoutCardInfoText,
            "at-areamap": Areamap,
            "at-poly-icon": PolygonIcon,
            "at-circle-icon": CircleIcon,
            "at-ellipsifier": Ellipsifier,
            "at-location-terminal-set": LocationTerminalSet,
            "at-syncinfo-dialog": SyncInfoDialog,
            "at-location-info-text": LocationInfoText,
            "at-location-occurring-cost-info-dialog": LocationOccurringCostInfoDialog,
        }
    })
    export default class LocationSetupWizard extends CompanyUserRequired {
        @Inject()
        api!: Api;

        @Prop({default: 0})
        locationId!: number;

        loading = false;

        @Prop({default: 1})
        pStep!: number;

        searchAddressToPass: string | null = null;

        focusedArea: Area | null = null;

        get step() {
            return this.pStep;
        }
        set step(v) {
            if(v === 2) {
                if (this.step1Ok) {
                    this.routeToStep(v);
                }
            } else if(v >= 4) {
                if(this.step3Ok) {
                    this.routeToStep(v);
                }
            } else {
                this.routeToStep(v);
            }
        }

        locationAddressBlur() {
          this.searchAddressToPass = this.location?.address ?? null;
        }

        // Change url to point to given step, thereby navigating to it via pStep
        routeToStep(step: number) {
            const locid = this.location && this.location.id || this.locationId;
            const route = LocationSetupWizard.routeName(locid, step, this.company.orgNum);
            if(this.step === step) {
                // When not moving to another step, replace instead of push, so that back button works as intended after.
                ignoreRedundantNavErr(this.$router.replace(route));
            } else {
                ignoreRedundantNavErr(this.$router.push(route));
            }
        }

        static routeName(locid: number, step: number, orgnum: number) {
            return {name: rd.locations.setup.name, query: {"location-id": locid.toString(), "step": step.toString(), "orgnum": orgnum.toString()}}
        }

        // Only company admin or terminal setup roles can create new locations
        get setupAllowed(): boolean {
          const allowed = this.user.isCompanyAdmin(this.company.orgNum) || this.user.isCompanyTerminalSetup(this.company.orgNum);
          if(!allowed) { // Try reloading user permissions to see if they're outdated.
            this.baseApi.loadUser();
          }
          return allowed;
        }

        // step 1
        showDescriptionInfo = false;
        showLocationInfo = false;

        @Watch("locationId", {immediate: true})
        async onLocationIdChanged() {
            // Reload location
            if(this.locationId > 0) {
                try {
                    this.loading = true;
                    this.location = await this.api.fetchTerminalLocation(this.locationId);
                    this.locationAreas = await this.api.fetchTerminalLocationAreas(this.location.id);
                    await this.fetchPendingConfigs();
                } finally {
                    this.loading = false;
                }
            } else {
                this.location = new TerminalLocation(
                    0, "", this.company.orgNum, false, null, null,
                    null, null, true, true, true,
                    false, 0, false, true
                );
                this.hmsregInfo.isCompanyActivated = await this.api.hmsregIsCompanyActivated(this.company.orgNum);
                this.exportServiceInfoList = (await this.api.companyExportserviceInfoList(this.company.orgNum)).filter(i => i.active);
            }
        }

        @Watch("pStep", {immediate: true})
        onPstepChanged() {
            if(this.locationId > 0 && this.pStep < 4) {
                const nextStep = this.step4Enabled ? 4 : 5;
                const rn = LocationSetupWizard.routeName(this.locationId, nextStep, this.company.orgNum);
                console.info(`Entering ${this.pStep} after location is created is not allowed. Redirecting to step ${nextStep}`);
                this.emitSnack(`Anlegg ${this.locationId} allerede opprettet, steg ${nextStep} første tilgjengelige`, "info");
                this.$router.replace(rn);
            }
        }

        location: TerminalLocation | null = null;


        hmsregInfo = new TerminalLocationHmsregInfo(null, false);
        exportServiceInfoList: TerminalLocationExportserviceInfo[] = [];

        validateLocDescription() {
            return this.location == null || this.location.description.trim().length > 2 || "Beskrivelse må ha minst tre tegn";
        }

        get step1Ok() {
            return this.location != null && this.validateLocDescription() === true;
        }
        // Validation rule for step1
        step1Rule() {
            return this.step == 1 || this.step1Ok;
        }

        // step 2
        showRegWithoutTerminalInfo = false;
        showRequireRegcodeInitInfo = false;
        showRegWithoutCardInfo = false;
        showHmsregInfo = false;
        expsvcInfoIdx = -1;
        get showExpsvcInfo() {
            return this.expsvcInfoIdx > -1;
        }
        set showExpsvcInfo(v: boolean) {
            if(!v) {
                this.expsvcInfoIdx = -1;
            }
        }
        get showExpsvcInfoDescription() {
            return this.showExpsvcInfo ? this.exportServiceInfoList[this.expsvcInfoIdx].description : "";
        }

        // step 3
        locationAreas: TerminalLocationArea[] = [];
        mapEnabled = false;
        editable = false;
        mapAreas: Area[] = [];
        readonly drawingmethodCircle = Drawingmethod.CIRCLE;
        readonly drawingmethodPolygon = Drawingmethod.POLYGON;
        drawingmethod: Drawingmethod = this.drawingmethodPolygon; // Default is polygon
        showCreateLocationPrompt = false;

        get isEditing() {
            return this.editable;
        }
        drawCircle() {
            if(this.drawingmethod !== Drawingmethod.CIRCLE) {
                this.drawingmethod = Drawingmethod.CIRCLE;
                if(!this.isEditing) {
                    this.enableDrawing();
                }
            } else {
                this.editable = !this.editable;
            }
        }
        drawPolygon() {
            if(this.drawingmethod !== Drawingmethod.POLYGON) {
                this.drawingmethod = Drawingmethod.POLYGON;
                if(!this.isEditing) {
                    this.enableDrawing();
                }
            } else {
                this.editable = !this.editable;
            }
        }

        enableDrawing() {
            this.editable = true;
        }

        disableEditing() {
            this.editable = false;
        }

        async cancel() {
            this.disableEditing();
            if(this.location && this.location.id != 0) {
                this.locationAreas = await this.api.fetchTerminalLocationAreas(this.location.id);
            }
        }

        onMapChangedAreas() {
            this.disableEditing();
        }
        removeArea(removeIdx) {
            const toRemove = this.locationAreas[removeIdx];
            this.locationAreas = this.locationAreas.filter((v, idx) => idx != removeIdx);
            this.onMapChangedAreas();
        }

        get mapHeight() {
            if(window && window.screen && window.screen.availHeight > 800) {
                return '400px';
            }
            return '300px';
        }
        showAreadefinitionInfo = false;

        get readyToCreate() {
            return this.location && this.location.id === 0 && (!this.location.regWithoutTerminal || this.locationAreas.length > 0);
        }

        createLocationPrompt() {
          this.showCreateLocationPrompt = true;
        }

        // Create the location with any areas defined.
        async createLocation() {
            this.hmsregInfo.normalizeRegnum();
            if(this.location != null && this.location.id == 0) {
                const resp1 = await this.api.createNewTerminalLocation(this.location, this.hmsregInfo, this.exportServiceInfoList);
                if (resp1 instanceof ApiMessage) {
                    this.emitError(new Error(resp1.msg));
                } else {
                    // Refresh user roles in case the create operation granted a new terminal location admin role
                    await this.baseApi.loadUser();
                    this.location = resp1.termloc;
                    // Set regcode
                    const resp2 = await this.api.createTerminalLocationRegcode(this.location.id);
                    if (resp2 instanceof ApiMessage) {
                        this.emitSnack(`Anlegg opprettet, men kunne ikke opprette anleggskode: ${resp2.msg}`, "warning");
                    } else {
                        this.emitSnack(`Anlegg opprettet.`, "success");
                    }
                    // Set area definition(s)
                    try {
                        // First add the correct new location id to the locationAreas, otherwise the server will bork on it.
                        const locid: number = this.location.id;
                        const locationAreas = this.locationAreas.map((a) => {
                            a.terminalLocationId = locid;
                            return a;
                        });
                        await this.api.saveTerminalLocationAreas(this.location.id, locationAreas);
                    } catch (e) {
                        this.emitError(new Error(`Anlegg opprettet, men anleggsområde ikke definert: ${e}`));
                    }

                    this.step = this.step4Enabled ? 4 : 5;
                }
            } else {
                this.emitError(new Error("location not set, or already created"));
            }
        }

        get step4Enabled() {
            return this.location == null || this.location.regWithoutTerminal;
        }

        get step3Ok() {
            return this.location && this.location.id > 0;
        }

        // step 4
        get locationPosterUrl() {
            return Routes.terminalLocationPosterPdf(this.locationId);
        }

        // step 5
        showTerminalInfo = false;
        existingTerminals: TerminalGuiInfo[] = [];
        showLocationTerminalSet = false;
        pendingConfigs: TerminalConfigNext[]= [];

        async fetchExistingTerminals() {
            this.existingTerminals = await this.api.fetchTerminals(this.company.orgNum, false);
        }

        async fetchPendingConfigs() {
            if(this.locationId > 0) {
                this.pendingConfigs = (await this.api.fetchTerminalsPendingOnLocation(this.locationId)).filter(pc => !pc.existingTerminal);
            } else {
                this.pendingConfigs = [];
            }
        }

        // existingTerminals list only needs to reload when company changes.
        @Watch("company", {immediate: true})
        cmpChanged() {
            if(this.company && this.company.orgNum !== 0) {
                this.fetchExistingTerminals();
            }
        }

        // Returns 1 if terminal is currently on location, 2 if it is pending to be
        private terminalLocCheck(t: TerminalGuiInfo): number {
            if(t.location != null && t.location.id === this.locationId) {
                return 1;
            }
            if(t.nextConfig != null && t.nextConfig.location != null && t.nextConfig.location.id === this.locationId) {
                return 2;
            }
            return 0;
        }

        get terminalsNotOnThis() {
            return this.existingTerminals.filter(t => this.terminalLocCheck(t) === 0);
        }
        get terminalsOnThis() {
            return this.existingTerminals.filter(t => this.terminalLocCheck(t));
        }

        // Count of terminals that are not busy on a location
        get freeTerminalCount() {
            return this.terminalsNotOnThis
                .filter((t) => t.location == null && (t.nextConfig == null || t.nextConfig.location == null)).length;
        }
        // Count of terminals that are busy on a location
        get busyTerminalCount() {
            return this.terminalsNotOnThis.length - this.freeTerminalCount;
        }

        get locationTo() {
            return {name: rd.locations.location.name, params: {locationId: this.locationId}};
        }

        get shopTo() {
            return {name: rd.shop.name, query: {"chosen-location-id": this.locationId}};
        }

        get roleDocTo() {
          return rd.docs.roleinfo.path;
        }

        terminalTo(t: Terminal) {
            return {name: rd.terminals.terminal.name, params: {guid: t.guid}};
        }
        pendingTerminalPageTo(guid: string) {
            return {name: rd.terminals.pending.name, params: {guid: guid}};
        }
        // When this is set, terminal sync dialog is shown, to get user to sync given terminal (after location setting)
        promptTerminalSyncGuid: string | null = null;
        get showTerminalSyncDialog() {
            return this.promptTerminalSyncGuid != null;
        }
        set showTerminalSyncDialog(v: boolean) {
            if(!v) {
                this.promptTerminalSyncGuid = null;
                Promise.resolve().then(async () => {
                    // Wait a bit, then reload to see if terminal is synced.
                    await delay(5000);
                    // Reload to display updated info
                    await this.fetchExistingTerminals();
                    await this.fetchPendingConfigs();
                })
            }
        }

        terminalSet(ti: Terminal) {
            this.promptTerminalSyncGuid = ti.guid;
            // Reload to display updated info
            this.fetchPendingConfigs();
            this.fetchExistingTerminals();
        }
    }

